import * as yup from "yup"

export const hasFutureCount = (value) => Number(value) > 0

export const isFutureSection = (setupRow, section) => {
	const sectionName = String(section?.name || "").toLowerCase()
	return (
		Boolean(setupRow?.isFuture) ||
		Boolean(section?.isFuture) ||
		sectionName.includes("future") ||
		sectionName.includes("remaining") ||
		sectionName.includes("concept")
	)
}

export const futureStatusValidation = () =>
	yup.string().nullable().when("futures", {
		is: hasFutureCount,
		then: (schema) => schema.required("Required"),
		otherwise: (schema) => schema.nullable().notRequired(),
	})
